import React from 'react';

const SectionTitle = ({titleText}) => { 
    return <h1>{titleText}</h1>
}

export default SectionTitle;